var map = {
	"./flags/ae.svg": "d436",
	"./flags/af.svg": "b7a1",
	"./flags/ag.svg": "32a6",
	"./flags/ai.svg": "33df",
	"./flags/al.svg": "3639",
	"./flags/am.svg": "cb30",
	"./flags/an.svg": "2027",
	"./flags/andorra.svg": "bf53",
	"./flags/ao.svg": "300e",
	"./flags/aq.svg": "f5b3",
	"./flags/ar.svg": "9cda",
	"./flags/as.svg": "7e72",
	"./flags/at.svg": "4d15",
	"./flags/au.svg": "444a",
	"./flags/aw.svg": "d746",
	"./flags/ax.svg": "79ef",
	"./flags/az.svg": "31e2",
	"./flags/ba.svg": "8b11",
	"./flags/bb.svg": "9904",
	"./flags/bd.svg": "f115",
	"./flags/be.svg": "55cb",
	"./flags/bf.svg": "1148",
	"./flags/bg.svg": "9487",
	"./flags/bh.svg": "be51",
	"./flags/bi.svg": "0303",
	"./flags/bj.svg": "38b7",
	"./flags/bl.svg": "ab24",
	"./flags/bm.svg": "1212",
	"./flags/bn.svg": "1dc8",
	"./flags/bnl.svg": "437a",
	"./flags/bo.svg": "957d",
	"./flags/bq.svg": "da75",
	"./flags/br.svg": "8d78",
	"./flags/bs.svg": "a9a3",
	"./flags/bt.svg": "71fb",
	"./flags/bv.svg": "1822",
	"./flags/bw.svg": "b140",
	"./flags/by.svg": "aea8",
	"./flags/bz.svg": "a0d6",
	"./flags/ca.svg": "650f",
	"./flags/cc.svg": "c430",
	"./flags/cd.svg": "006a",
	"./flags/cf.svg": "953e",
	"./flags/cg.svg": "09a2",
	"./flags/ch.svg": "e005",
	"./flags/ci.svg": "87ba",
	"./flags/ck.svg": "992d",
	"./flags/cl.svg": "1236",
	"./flags/cm.svg": "0e2e",
	"./flags/cme.svg": "5ea8",
	"./flags/cn.svg": "cf0f",
	"./flags/co.svg": "3d35",
	"./flags/cr.svg": "fbb9",
	"./flags/cu.svg": "76fb",
	"./flags/cv.svg": "b37e",
	"./flags/cw.svg": "ccce",
	"./flags/cx.svg": "96bc",
	"./flags/cy.svg": "8717",
	"./flags/cz.svg": "da2b",
	"./flags/de.svg": "93c2",
	"./flags/dj.svg": "4cf6",
	"./flags/dk.svg": "b8d7",
	"./flags/dm.svg": "4366",
	"./flags/do.svg": "cb78",
	"./flags/dz.svg": "8456",
	"./flags/ec.svg": "efa5",
	"./flags/ee.svg": "3446",
	"./flags/eex.svg": "7976",
	"./flags/eg.svg": "b90d",
	"./flags/eh.svg": "ad01",
	"./flags/el.svg": "c689",
	"./flags/er.svg": "ab28",
	"./flags/es-ca.svg": "9599",
	"./flags/es.svg": "b45f",
	"./flags/et.svg": "2af2",
	"./flags/eu.svg": "676f",
	"./flags/eu10.svg": "41a9",
	"./flags/eu15.svg": "101e",
	"./flags/eu27.svg": "dc51",
	"./flags/eu28.svg": "067b",
	"./flags/eueast.svg": "b53a",
	"./flags/fi.svg": "027f",
	"./flags/fj.svg": "e9a1",
	"./flags/fk.svg": "3963",
	"./flags/flag_3regions.svg": "7785",
	"./flags/fm.svg": "679c",
	"./flags/fo.svg": "b4c2",
	"./flags/fr.svg": "95e0",
	"./flags/fraatla.svg": "9b6b",
	"./flags/ga.svg": "a9c7",
	"./flags/gb-eng.svg": "14e2",
	"./flags/gb-nir.svg": "8ee8",
	"./flags/gb-sct.svg": "1319",
	"./flags/gb-wls.svg": "7937",
	"./flags/gb.svg": "a2e3",
	"./flags/gd.svg": "0e83",
	"./flags/gdt.svg": "ab64",
	"./flags/ge.svg": "0ae1",
	"./flags/gf.svg": "490d",
	"./flags/gg.svg": "e6c5",
	"./flags/gh.svg": "2fb9",
	"./flags/gi.svg": "0327",
	"./flags/gl.svg": "20b8",
	"./flags/gm.svg": "be97",
	"./flags/gn.svg": "78a3",
	"./flags/gp.svg": "8e9c",
	"./flags/gq.svg": "a3c6",
	"./flags/gr.svg": "283b",
	"./flags/gs.svg": "e268",
	"./flags/gt.svg": "f290",
	"./flags/gu.svg": "a5ee",
	"./flags/gw.svg": "78ab",
	"./flags/gy.svg": "c06c",
	"./flags/hk.svg": "272f",
	"./flags/hm.svg": "fa5e",
	"./flags/hn.svg": "e880",
	"./flags/hr.svg": "391d",
	"./flags/ht.svg": "0b4b",
	"./flags/hu.svg": "cda8",
	"./flags/id.svg": "3459",
	"./flags/ie.svg": "6c63",
	"./flags/il.svg": "86b0",
	"./flags/im.svg": "d5fe",
	"./flags/in.svg": "aa6f",
	"./flags/io.svg": "b307",
	"./flags/iq.svg": "a4d0",
	"./flags/ir.svg": "2e69",
	"./flags/is.svg": "5772",
	"./flags/it.svg": "b468",
	"./flags/je.svg": "18a5",
	"./flags/jm.svg": "bf65",
	"./flags/jo.svg": "6a3a",
	"./flags/jp.svg": "9810",
	"./flags/ke.svg": "0606",
	"./flags/kg.svg": "26c9",
	"./flags/kh.svg": "d14e",
	"./flags/ki.svg": "2ba7",
	"./flags/km.svg": "3c10",
	"./flags/kn.svg": "f814",
	"./flags/kp.svg": "6f33",
	"./flags/kr.svg": "954b",
	"./flags/kw.svg": "181b",
	"./flags/ky.svg": "7ef8",
	"./flags/kz.svg": "b95e",
	"./flags/la.svg": "647d",
	"./flags/latam.svg": "020d",
	"./flags/lb.svg": "1818",
	"./flags/lc.svg": "0db4",
	"./flags/li.svg": "186a",
	"./flags/lk.svg": "5b70",
	"./flags/lr.svg": "14ff",
	"./flags/ls.svg": "a9b3",
	"./flags/lt.svg": "6d49",
	"./flags/lu.svg": "f95f",
	"./flags/lv.svg": "2ba5",
	"./flags/ly.svg": "88b6",
	"./flags/ma.svg": "bab5",
	"./flags/mc.svg": "365b",
	"./flags/md.svg": "1586",
	"./flags/me.svg": "2435",
	"./flags/mf.svg": "0078",
	"./flags/mg.svg": "8055",
	"./flags/mh.svg": "50a0",
	"./flags/mk.svg": "f7de",
	"./flags/ml.svg": "a2d7",
	"./flags/mm.svg": "7049",
	"./flags/mn.svg": "b26f",
	"./flags/mo.svg": "1ff6",
	"./flags/mp.svg": "d143",
	"./flags/mq.svg": "5e9f",
	"./flags/mr.svg": "6481",
	"./flags/ms.svg": "996e",
	"./flags/mt.svg": "8baf",
	"./flags/mu.svg": "aa17",
	"./flags/mv.svg": "69f8",
	"./flags/mw.svg": "8ce2",
	"./flags/mx.svg": "a407",
	"./flags/my.svg": "2dab",
	"./flags/mz.svg": "bc63",
	"./flags/na.svg": "1bc4",
	"./flags/nc.svg": "5ba8",
	"./flags/ne.svg": "c1bf",
	"./flags/nf.svg": "cbf1",
	"./flags/ng.svg": "9677",
	"./flags/ni.svg": "e6fb",
	"./flags/nl.svg": "2cf1",
	"./flags/no.svg": "c43d",
	"./flags/np.svg": "6749",
	"./flags/nr.svg": "f11b",
	"./flags/nu.svg": "3868",
	"./flags/nz.svg": "8356",
	"./flags/nzx.svg": "ae30",
	"./flags/om.svg": "8b0c",
	"./flags/pa.svg": "c291",
	"./flags/pe.svg": "fd1f",
	"./flags/pf.svg": "3051",
	"./flags/pg.svg": "84c3",
	"./flags/ph.svg": "cd26",
	"./flags/pk.svg": "a249",
	"./flags/pl.svg": "411d",
	"./flags/pm.svg": "f555",
	"./flags/pn.svg": "a3b4",
	"./flags/pr.svg": "99d5",
	"./flags/ps.svg": "2508",
	"./flags/pt.svg": "a673",
	"./flags/pw.svg": "c8dc",
	"./flags/py.svg": "8147",
	"./flags/qa.svg": "1855",
	"./flags/re.svg": "4466",
	"./flags/ro.svg": "bc8a",
	"./flags/rs.svg": "41d0",
	"./flags/ru.svg": "fc3f",
	"./flags/rw.svg": "9549",
	"./flags/sa.svg": "a2b1",
	"./flags/sb.svg": "ef12",
	"./flags/sc.svg": "e481",
	"./flags/sd.svg": "6e0c",
	"./flags/se.svg": "c6d1",
	"./flags/sg.svg": "7bb3",
	"./flags/sgx.svg": "7794",
	"./flags/sh.svg": "ea4b",
	"./flags/si.svg": "291f",
	"./flags/sj.svg": "61b0",
	"./flags/sk.svg": "ec82",
	"./flags/sl.svg": "9854",
	"./flags/sm.svg": "687c",
	"./flags/sn.svg": "a8e4",
	"./flags/so.svg": "4b90",
	"./flags/sr.svg": "02e2",
	"./flags/ss.svg": "afb1",
	"./flags/st.svg": "bf08",
	"./flags/sv.svg": "3f04",
	"./flags/sx.svg": "588b",
	"./flags/sy.svg": "23ab",
	"./flags/sz.svg": "e2d7",
	"./flags/tc.svg": "ed93",
	"./flags/td.svg": "0c16",
	"./flags/tf.svg": "66e4",
	"./flags/tg.svg": "5fcf",
	"./flags/th.svg": "c581",
	"./flags/tj.svg": "d92d",
	"./flags/tk.svg": "d53c",
	"./flags/tl.svg": "7821",
	"./flags/tm.svg": "40d1",
	"./flags/tn.svg": "1ce1",
	"./flags/to.svg": "8659",
	"./flags/tr.svg": "6919",
	"./flags/tt.svg": "e06f",
	"./flags/tv.svg": "3966",
	"./flags/tw.svg": "e07f",
	"./flags/tz.svg": "5520",
	"./flags/ua.svg": "b997",
	"./flags/ug.svg": "f56c",
	"./flags/uk.svg": "b5c9",
	"./flags/um.svg": "c2a0",
	"./flags/un.svg": "3ab3",
	"./flags/us.svg": "a513",
	"./flags/uy.svg": "d3aa",
	"./flags/uz.svg": "936f",
	"./flags/va.svg": "2a6f",
	"./flags/vc.svg": "f51a",
	"./flags/ve.svg": "dc84",
	"./flags/vg.svg": "5027",
	"./flags/vi.svg": "b180",
	"./flags/vn.svg": "13b5",
	"./flags/vpi-2.svg": "8159",
	"./flags/vpi-3.svg": "9471",
	"./flags/vpi.svg": "0a98",
	"./flags/vu.svg": "4c68",
	"./flags/wf.svg": "e151",
	"./flags/world.svg": "41bf",
	"./flags/ws.svg": "44a1",
	"./flags/xk.svg": "aae6",
	"./flags/xs.svg": "1fa6",
	"./flags/ye.svg": "4111",
	"./flags/yt.svg": "bd45",
	"./flags/za.svg": "3dd3",
	"./flags/zm.svg": "6a4e",
	"./flags/zw.svg": "31af",
	"./ico-arrow-negative.svg": "73e7",
	"./ico-arrow-neutral.svg": "93e3",
	"./ico-arrow-positive.svg": "361b",
	"./ico-close.svg": "c71f",
	"./logo-dark.svg": "a599",
	"./logo-old.svg": "4ad1",
	"./logo-shape-only.svg": "0c22",
	"./logo.svg": "1ae4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";